import { WORK_SPACE_ROOT_FOLDER } from '../constants/constants';

import {Folder, LegalEntity, TreatmentCategory} from "../api/ms-organization-entities";
import {Application} from "it/primatoo/openapi/api/org/schemas/application/Application";
import {
  ListAppForNewAssessmentResponse
} from "it/primatoo/openapi/api/org/schemas/appassessment/ListAppForNewAssessmentResponse";
import { Application as App} from 'it/primatoo/openapi/api/org/schemas/appassessment/Application';
import { Department } from 'it/primatoo/openapi/api/org/schemas/department/Department';
import { User } from 'it/primatoo/openapi/api/org/schemas/user/listuserformenuresponse/User';

export class NavigationData {
  id?: number;
  name?: string;
  image?: string;
  parentId?: number | null;
  auth?: boolean;

  static legalEntityToNavigationData(legalEntity: LegalEntity): NavigationData | null {
    if (legalEntity) {
      return {
        id: legalEntity.id,
        name: legalEntity.name,
        image: 'legal-entity.svg',
        parentId: legalEntity.parentLegalEntityId,
        auth: true
      } as NavigationData;
    }
    return null;
  }

  static folderToNavigationData(folder: Folder): NavigationData | null {
    if (folder) {
      if (folder.name === WORK_SPACE_ROOT_FOLDER) {
        return {
          id: folder.id,
          name: folder.name,
          image: 'home.svg',
          parentId: folder.parentId,
          auth: true
        } as NavigationData;
      } else {
        return {
          id: folder.id,
          name: folder.name,
          image: 'folder.svg',
          parentId: folder.parentId,
          auth: true
        } as NavigationData;
      }
    }
    return null;
  }

  static departmentToNavigationData(item: Department) {
    if (item) {
      return {
        id: item.id,
        name: item.name,
        image: 'department.svg',
        parentId: null,
        auth: true
      } as NavigationData;
    }
    return null;
  }

  static treatmentCategoryToNavigationData(treatmentCategory: TreatmentCategory) {
    if (treatmentCategory) {
      return {
        id: treatmentCategory.id,
        name: treatmentCategory.label,
        image: 'treatment.svg',
        parentId: null,
        auth: true
      } as NavigationData;
    }
    return null;
  }

  static listAppForNewAssessmentResponseToNavigationData(list: ListAppForNewAssessmentResponse): NavigationData[] {
    return list.apps.map((app: App) => {
      return {
        id: app.id,
        name: app.name,
        image: 'applications.svg',
        parentId: null,
        auth: true
      } as NavigationData;
    }) || []
  }
  static applicationToNavigationData(application: Application) {
    if (application) {
      return {
        id: application.id,
        name: application.name,
        image: 'applications.svg',
        parentId: null,
        auth: true
      } as NavigationData;
    }
    return null;
  }

  static userToNavigationData(user: User) {
    if (user) {
      return {
        id: user.id,
        name: user.fullName,
        image: 'user.svg',
        parentId: null,
        auth: true
      } as NavigationData;
    }
    return null;
  }

}
